var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('van-image',{staticStyle:{"width":"100vw"},attrs:{"src":_vm.smallLogo}}),_vm._v(" "),_c('van-image',{staticStyle:{"width":"60vw"},attrs:{"src":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }